/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import { FiraSansBold, Text } from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";
import { Field } from 'formik';
import { mediaHelper } from 'utils/src/media-helper';
import Row from 'components/Grid/Row';
import globalStyles from "globalStyles";
const { list2, button } = globalStyles.components;

const ListContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 0 1rem;
  margin: 0 auto;
  flex-basis: 0;
  flex-grow: 1;

  @media screen and (min-width: ${Breakpoints.md}) {
    width: 90%;
    padding: unset;
  }
`;

export { ListContainer };


export const CalendarContainer = styled.div`
  position: absolute;
  margin: 4px;
  z-index: 55;
  top: 35px;
  right: 2px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content-old: flex-end;
  justify-content-old: left;
  margin-top: 0px;
  margin-bottom: 3rem;
`;

const ButtonContainer_OLD = styled.div`
  display: flex;
  justify-content-old: flex-end;
  justify-content-old: left;
  margin-top: 48px;
`;

export { ButtonContainer };

const HeaderRowContainer = styled.div`
  background-color: gray;
`;

export { HeaderRowContainer };

/* const LinkSort = ({ dataOrder, className, onClick, children }) => (
  <a data-order={dataOrder} className={className} onClick={onClick}>
    {children}
  </a>
);

const ButtonSort = styled(LinkSort)`
  cursor: pointer;
  font-size: 14px;
`; */

/* export { ButtonSort }; */

export const DialogSelect = styled.div`
  width: 100%;  
  margin: 30px 0px 10px 0px;
`;

export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${button.primaryMixin.secondary};
  border: 0px;
  border-radius: 5px;
  font-weight: ${FiraSansBold};
  font-size: 14px;
  font-family: 'Fira Sans', sans-serif;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: ${FiraSansBold};
  font-size: 14px;
  font-family: 'Fira Sans', sans-serif;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const DialogRejected = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.PURPLE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
`;

export const NewEnquiryButton = styled.button`
  width: calc(25% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${button.primaryMixin.secondary};
  border: 0px;
  border-radius: 5px;
  font-weight: ${FiraSansBold};
  font-size: 14px;
  font-family: 'Fira Sans', sans-serif;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


export const CustomField = styled.div`
  display: inline-flex;
  width: 70%;
  vertical-align: middle;
  
  div{
    min-height: auto;
    margin-bottom: 0px;
    width: 100%;
  }
  .is-approved{
    span{
      color: ${Colors.GRAY[0]};
    }
  }
  .is-disabled{
    span{
      color: ${Colors.GRAY[3]}
    }
  }
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: unset;
    width: unset;
    vertical-align: unset;
  }
`;


export const ContentAlert = styled.div`
  width: 100%;  
  margin-top: 20px;
  p{
    color: ${Colors.GRAY[1]};
    margin-bottom: 30px;
    margin-top: 0px;
    font-weight: 500;
    font-size: 14px;
  }
`;


export const Textarea = styled.textarea`
    width: 100%;
    height: 100px;
    border: 1px solid #888;
    border-radius: 4px;
    margin-top: 0px;
    padding: 14px;
    margin-bottom: 10px;
`;

export const ContentTextarea = styled.div`
  width: 100%;  
  margin-top: 0px;
  margin-bottom: 0px;
  p{
    color: ${Colors.GRAY[0]};
    margin-bottom: 5px;
    margin-top: 10px;
    font-weight: 800;
    font-size: 14px;
  }
`;

export const InlineLabel = styled(Text)`
  display: inline-flex;
  width: 50px;
  vertical-align: middle;
  padding-right: 5px;
  
  font-size: 13px;
  color: ${Colors.GRAY[3]};
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: none;
  }
`;

export const ActionContainer = styled.div`
  display: inline-flex;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  flex-direction: row;
  text-align: center;
  padding-right:20px;
  @media screen and (min-width: ${Breakpoints.md}) {
    align-itens: center;
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    flex-direction: column;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  
  i {
    width: 20px;
    height: 20px;  
  }
  
  i:first-child {
    /* margin-right: 10px; */
  }
  
  i:before {
    background-size: 20px 20px;
    width: 20px;
    height: 20px;
  }
`;

export const MobileContainer = styled.div`
  &.filter-open {
    display: block;
    position: fixed;
    overflow-x: scroll;
    top: 0;
    height: 100%;
    left: 0;
    width: 100%;
    background-color: ${Colors.WHITE};
    z-index: 2000;
    padding: 1rem 2rem;
    
    > div > div {
      background-color: ${Colors.WHITE};
    }
  }
  
  &.filter-close {
    display: none;
  }
  
  .icon-close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 10px 15px;
    font-size: 30px;
  }
  
  @media screen and (min-width: ${Breakpoints.md}) {
    &.filter-open {
      display: unset;
      position: unset;
      overflow-x: unset;
      top: unset;
      height: unset;
      left: unset;
      width: unset;
      background-color: revert;
      z-index: unset;
      padding: unset;
    }
    &.filter-close {
      display: unset;
    }
    .icon-close {
      display: none;
    }
  }
`;

export const MobileFilterOrder = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  
  > div:first-child > div {
    text-align: center;
  }
  
  hr {
    width: 100%;
    border: 1px solid ${Colors.GRAY[3]}
  }
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: block;
    
    hr {
      display: none;
    }
  }
`;

export const RowFilterSearch = styled(Row)`
  background-color: ${Colors.GREEN};
  border-radius: 10px 10px 0 0;
  margin-bottom: 10px;
  padding: 7px 0;
  
  > div:first-child {
    display: block;
  }
  
  ${mediaHelper.sm`
    border-radius: 15px 15px 0 0;
  `}
  
  @media screen and (min-width: ${Breakpoints.md}) {
    background-color: ${Colors.GREEN} !important;
    border-radius: 20px 20px 0 0;
    margin-bottom: unset;
    
    > div:first-child {
      display: none;
    }
  }
`;

export const Line = styled.div`
    width: 100%;
    height: 2px;
    margin: 5px 0;
    background-color: ${Colors.GRAY[4]};
`;

export const MobileLabel = styled.span`
  font-weight: ${FiraSansBold};
  text-transform: uppercase;
  font-size: 16px;
  color: ${Colors.GREEN};
`;

export const RowFilter = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding: 5px;
`;

export const CheckBoxColumn = styled.div`
  width: 20%;
`;

export const FilterColumn = styled.div`
  width: 100%;
`;

export const FieldGrid = styled(Field)`
  border-radius: 4px;
  padding-left: 5px;
  vertical-align: middle;
`

export const FilterContainer = styled.div`
  z-index: 55;

  &.filter-close {
    display: none;
  }

  &.filter-open {
    position: absolute;
    right: 0;
    top: 60px;
    background-color: ${Colors.WHITE};
    z-index: 10;
    padding: 15px;
    width: 350px;
    box-shadow: -5px 5px 20px -10px black;
    
    > div > div {
      background-color: ${Colors.WHITE};  
    }
  }

  @media (max-width: ${Breakpoints.md}) {
    &.filter-close {
      display: none;
    }
  
    &.filter-open {
      position: fixed;
      overflow-x: scroll;
      top: 0;
      height: 100%;
      left: 0;
      width: 100%;
      background-color: ${Colors.WHITE};
      z-index: 2000;
      padding: 10px;
  
      > div > div {
        background-color: ${Colors.WHITE};  
      }
    }
    
    .icon-close {
      position: absolute;
      top: 0;
      right: 0;
      margin: 10px 15px;
      font-size: 30px;
    }
  }
`;

export const FilterSearchContainer = styled.div`
  border-radius: 20px 20px 0 0;
  width: 100%;
  margin-bottom: 10px;
`;

export const RowFilterIcon = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: end;
  flex-direction: row;
  background-color: ${list2.rowFilter};
  border-radius: 20px 20px 0 0;
  margin-bottom: 10px;
  padding: 7px 10px;
  position: relative;

  @media (max-width: ${Breakpoints.md}) {
    border-radius: 10px 10px 0 0;
  }
`;

export const RowOrderFilter = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${Breakpoints.md}) {
    display: none;
  }
`;

export const RowOrderFilterMobile = styled.div`
  display: none;

  @media (max-width: ${Breakpoints.md}) {
    display: flex;
    flex-direction: column;
  }
`;

export const ColIcon = styled.div`
  display: flex;
  margin: 0px;
  padding: 5px;
  justify-content: flex-start;
  align-items: center;
`

export const ContainerProducts = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
`

export const ItemProduct = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  cursor: pointer;
  max-width: 220px;
  width: 220px;
`

export const TitleProducts = styled.span`
  font-weight: 700;
  font-size: 12px;
  color: #53565A;
  text-transform: uppercase;
  max-width: 125px;
  align-self:center;
  margin-left: 7px;
`


export const Table = styled.table`
  border-collapse: collapse;
  padding: 0;
  width: 100%;
  table-layout: fixed;
`

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`
export const Counter = styled.span`
  color: ${Colors.WHITE};
  font-weight: 600;
  width: 250px;
`;

export const TableBody = styled.tbody`
  tr {
    border-bottom: 2px solid #E0E0E0;
  }
`

export const TableColumn = styled.td`
  vertical-align: middle;
  text-align: left;
  display: table=cell;
  width: 10%;


  &:first-child {
    /* padding-left: 15px; */
  }

  label {
    ${({ dealGroup }) => dealGroup && `color: ${Colors.BLACK}`};
  }

  &:last-child {
    /* padding-right: 25px; */
    text-align: center;
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    /* max-width: unset !important; */
    padding-top: 0px;
    padding-bottom: 2px;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`
export const TableColumnActions = styled.td`
  vertical-align: middle;
  text-align: right;
  padding-bottom: 8px;
  padding-top: 8px;
  padding-right: 5px;
  display: flex;
  justify-content: flex-end;

  &:first-child {
    /* padding-left: 15px; */
  }

  label {
    ${({ dealGroup }) => dealGroup && `color: ${Colors.BLACK}`};
  }

  &:last-child {
    /* padding-right: 15px; */
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`

export const TableHeader = styled.th`
  /* ${({ minWidth }) => minWidth ? `min-width: ${minWidth}px` : ''}
  ${({ maxWidth }) => maxWidth ? `width: ${maxWidth}px` : ''}
  ${({ width }) => width ? `width: ${width}px` : ''} */
  position: relative;
  vertical-align: top;
  padding: 5px;
  padding-left: 0px;
  text-align: left;
  span {
    color: Colors.GRAY[1];
  }

  &:first-child {
    /* padding-left: 15px; */
  }
  &:last-child {
    /* padding-right: 15px; */
  }
`

export const TableRow = styled.tr`
  ${({ dealGroup }) => dealGroup && `background: ${Colors.GRAY[3]}`}
`;


export const Content = styled.div`
  background-color: ${Colors.WHITE};
  border: 1px solid ${Colors.BLUE};
  margin: 0;
  border-radius: 10px
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;

  @media screen and (min-width: ${Breakpoints.sm}) {
    margin-top: 40px;
    margin-bottom: 10%;
    border-radius: 15px;
  }

  ${mediaHelper.md`
    border-radius: 20px;
  `}
`;

export const Installment = styled.div`
  padding-left: 16px;
`;